import { isNumber } from "lodash";
import moment from "moment";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatMoney = (data: any): string => {
  const {
    currency,
    amount = 0,
    hideZero = false,
    hideCurrency = false,
    hideAmount = false,
  } = data;
  // Amount is expected to be in "cents"; No decimals!!!
  // @todo support other currencies
  if (hideAmount) {
    return "—";
  }
  const roundedAmount = Math.round(amount);
  const dollars =
    roundedAmount < 0 ? (roundedAmount / 100) * -1 : roundedAmount / 100;

  // const userLocale =
  //   navigator.languages && navigator.languages.length
  //     ? navigator.languages[0]
  //     : navigator.language;
  //
  // console.log(userLocale);

  // Currently only supporting usd/cad; Will have to use userLocale to support dynamically
  const monies = "$" + dollars.toFixed(2);

  const currencyTxt = currency && !hideCurrency ? currency.toUpperCase() : "";

  if (hideZero && roundedAmount === 0) {
    return "";
  }

  const text = `${monies} ${currencyTxt}`.trim();

  return roundedAmount < 0 ? `(${text})` : text;
};

export const formatDate = (value: number): string => {
  if (value) {
    return isNumber(value) && value > 0
      ? moment.unix(value).format("MMM D YYYY")
      : value.toString();
  } else {
    return "";
  }
};
